import styled from 'styled-components';

export const SnackBarWrapper = styled.div`
  position: fixed;
  left: 100px;
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  bottom: ${({ show }) => (show ? '60' : '-100')}px;
  opacity: ${({ show }) => (show ? 1 : 0)};
  width: 400px;
  z-index: 9999;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme, color }) =>
    `0px 4px 16px rgb(${theme.colors.rgb.black16PercentOpacity}), inset 0px 4px 0px ${color}`};
  transition: all 1s ease-out;
`;

export const SnackBarContent = styled.div`
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
`;

export const SnackBarMessage = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;

  ${({ isFailMessage, theme }) => (isFailMessage ? theme.colors.redMain : theme.colors.grey600)}
`;

export const CloseIcon = styled.span`
  display: inline-table;
  font-size: 14px;
  margin-top: 1px;
  margin-inline-end: 5px;
  color: ${({ theme }) => theme.colors.grey600};
  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
  }
`;
